<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S127G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_17 col_31'><span class='brt high default' id='text3'>USAGE INFORMATION</span>  </div>
  <div class='lgr_20 col_59'><dynamic-field [id]='"revnbr"' [size]=20 [line]=2 [column]=59 [(ngModel)]='revnbr'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_38 col_01'><span class='brt high default' id='text4'>CONTROL/BOOK # CONJ       ACTIVTY DATE</span>  </div>
  <div class='lgr_40 col_40'><span class='brt high default' id='text5'>OUT SRC LOC AGENT     OVR IMG   COMM AMT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_25 col_01'><span class='brt high default' id='text6'>CONVERTED TKT # REFERENCE</span>  </div>
  <div class='lgr_36 col_44'><span class='brt high default' id='text7'>SETTLEMENT INFORMATION        AMOUNT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text8'>LIFT TYPE</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag1"' [size]=79 [line]=7 [column]=1 [(ngModel)]='usag1'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag2"' [size]=79 [line]=8 [column]=1 [(ngModel)]='usag2'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag3"' [size]=79 [line]=9 [column]=1 [(ngModel)]='usag3'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag4"' [size]=79 [line]=10 [column]=1 [(ngModel)]='usag4'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag5"' [size]=79 [line]=11 [column]=1 [(ngModel)]='usag5'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag6"' [size]=79 [line]=12 [column]=1 [(ngModel)]='usag6'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag7"' [size]=79 [line]=13 [column]=1 [(ngModel)]='usag7'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag8"' [size]=79 [line]=14 [column]=1 [(ngModel)]='usag8'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag9"' [size]=79 [line]=15 [column]=1 [(ngModel)]='usag9'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag10"' [size]=79 [line]=16 [column]=1 [(ngModel)]='usag10'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag11"' [size]=79 [line]=17 [column]=1 [(ngModel)]='usag11'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag12"' [size]=79 [line]=18 [column]=1 [(ngModel)]='usag12'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag13"' [size]=79 [line]=19 [column]=1 [(ngModel)]='usag13'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag14"' [size]=79 [line]=20 [column]=1 [(ngModel)]='usag14'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"usag15"' [size]=79 [line]=21 [column]=1 [(ngModel)]='usag15'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text9'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text10'>4-EXIT</span>  </div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text11'>3-MAIN</span>  </div>
  <div class='lgr_05 col_27'><dynamic-field [id]='"selmen"' [size]=5 [line]=23 [column]=27 [(ngModel)]='selmen'></dynamic-field></div>
  <div class='lgr_05 col_33'><span class='brt high default' id='text12'>5-ISS</span>  </div>
  <div class='lgr_06 col_39'><dynamic-field [id]='"prev"' [size]=6 [line]=23 [column]=39 [(ngModel)]='prev'></dynamic-field></div>
  <div class='lgr_06 col_46'><dynamic-field [id]='"next"' [size]=6 [line]=23 [column]=46 [(ngModel)]='next'></dynamic-field></div>
  <div class='lgr_08 col_53'><span class='brt high default' id='text13'>9-COUPON</span>  </div>
  <div class='lgr_07 col_62'><dynamic-field [id]='"pagt"' [size]=7 [line]=23 [column]=62 [(ngModel)]='pagt'></dynamic-field></div>
  <div class='lgr_08 col_70'><span class='brt high default' id='text14'>12-PRINT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text15'>SHIFT PF:</span>  </div>
  <div class='lgr_12 col_11'><dynamic-field [id]='"currc1"' [size]=12 [line]=24 [column]=11 [(ngModel)]='currc1'></dynamic-field></div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
  <div class='lgr_09 col_44'><dynamic-field [id]='"paymt"' [size]=9 [line]=24 [column]=44 [(ngModel)]='paymt'></dynamic-field></div>
  <div class='lgr_08 col_55'><dynamic-field [id]='"last"' [size]=8 [line]=24 [column]=55 [(ngModel)]='last'></dynamic-field></div>
  <div class='lgr_09 col_65'><dynamic-field [id]='"first"' [size]=9 [line]=24 [column]=65 [(ngModel)]='first'></dynamic-field></div>
</div>
</div>
